import "@/composables/useNotification";
import Multiselect from "vue-multiselect";
import ChemicalContainerRoutes from "@/pages/chemtracker/ChemicalContainerRoutes";

require("../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css");
require("../../../node_modules/pretty-checkbox/dist/pretty-checkbox.min.css");
require("../../css/FixTableColumn.css");
require("./css/chemtracker.css");
require("./css/chemtracker_sds.css");

const globalComponents = {
  MultiSelect: Multiselect,
};

export {
  ChemicalContainerRoutes as chemicalContainersRoutes,
  globalComponents as chemicalContainersGlobalComponents,
};
